import {
  Box,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState } from "react";
import { useQuiz } from "../Context/QuizContext";

const TextField = ({ label }) => {
  const [value, setValue] = useState("");
  const { setAmount } = useQuiz();

  const handleChange = (e) => {
    setAmount(e.target.value);
    setValue(e.target.value);
  };

  const options = Array.from({ length: 5 }, (_, i) => (i + 1) * 10);

  return (
    <Container maxWidth="sm">
      <Box mt={3} width="100%">
        <FormControl fullWidth size="small">
          <InputLabel>{label}</InputLabel>
          <Select value={value} label={label} onChange={handleChange}>
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Container>
  );
};

export default TextField;
